<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  min-height: 100vh;
  width: 100%;
}

/* Modern Custom Scrollbar Styling */
/* WebKit Browsers (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 4px;
  transition: all 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5855eb 0%, #7c3aed 100%);
  transform: scale(1.1);
}

::-webkit-scrollbar-thumb:active {
  background: linear-gradient(135deg, #4f46e5 0%, #6d28d9 100%);
}

::-webkit-scrollbar-corner {
  background: rgba(0, 0, 0, 0.05);
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #6366f1 rgba(0, 0, 0, 0.05);
}

/* Dark mode scrollbar */
@media (prefers-color-scheme: dark) {
  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #818cf8 0%, #a78bfa 100%);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  }

  ::-webkit-scrollbar-thumb:active {
    background: linear-gradient(135deg, #5855eb 0%, #7c3aed 100%);
  }

  ::-webkit-scrollbar-corner {
    background: rgba(255, 255, 255, 0.05);
  }

  /* Firefox dark mode */
  * {
    scrollbar-color: #818cf8 rgba(255, 255, 255, 0.05);
  }
}

/* Smooth scrolling behavior */
html {
  scroll-behavior: smooth;
}

/* Custom scrollbar for specific modal containers to ensure consistency */
.modal-content {
  scrollbar-width: thin;
  scrollbar-color: #6366f1 rgba(0, 0, 0, 0.05);
}

.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 3px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 3px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5855eb 0%, #7c3aed 100%);
}

@media (prefers-color-scheme: dark) {
  .modal-content {
    scrollbar-color: #818cf8 rgba(255, 255, 255, 0.05);
  }

  .modal-content::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.03);
  }

  .modal-content::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #818cf8 0%, #a78bfa 100%);
  }

  .modal-content::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  }
}
</style> 